<template>
  <div class="article-page">
    <article v-if="article">
      <div class="article-page__content">
        <div class="article-page__article" :title="article.fields.displayImage.fields.file.title" :alt="article.fields.displayImage.fields.description">
          <h1>{{ article.fields.title }}</h1>
          <p class="article-page__article__ingress">{{ article.fields.ingress }}</p>
          <div class="article-page__article__markdown" v-html="markdownToHtml(article.fields.textContent)"></div>
          <ContactPersonAtom v-if="contactPerson.name" :contactPerson="contactPerson" />
        </div>
      </div>
    </article>
    <div class="article-page__share-button">
      <ShareAtom :lightTheme="false" />
    </div>
  </div>
</template>

<script>
import ShareAtom from '../atoms/ShareAtom.vue';
import ContactPersonAtom from '../atoms/ContactPersonAtom.vue';
import api from '@/api/contentful.js';

const marked = require('marked');

export default {
  name: 'ArticlePage',
  components: {
    ShareAtom,
    ContactPersonAtom,
  },
  data() {
    return {
      article: false,
      relatedArticles: false,
    };
  },
  computed: {
    contactPerson() {
      return {
        name: this.article.fields.author?.fields?.name,
        email: this.article.fields.author?.fields?.email,
        linkedIn: this.article.fields.author?.fields?.linkedIn,
        instagram: this.article.fields.author?.fields?.instagram,
        title: this.article.fields.author?.fields?.title,
      };
    },
  },
  methods: {
    async fetchArticle() {
      this.article = await api.getArticle(this.$route.params.id);
      if (this.article === undefined) {
        this.$router.push({ name: 'notFound' });
      }
    },
    // async fetchRelatedArticles(limit, skip) {
    //   let relatedArticles = await api.getArticles(limit, skip);
    //   this.relatedArticles = relatedArticles.filter((article) => article.sys.id !== this.$route.params.id).slice(0, 3);
    // },
    markdownToHtml(string) {
      return marked.parse(string);
    },
  },
  mounted() {
    this.fetchArticle();
    // await this.fetchRelatedArticles(4, 0);
  },
};
</script>

<style scoped>
.article-page__article {
  min-width: 400px;
  max-width: 800px;
  padding: 170px 30px 30px 30px;
  align-content: center;
}

.article-page__content {
  display: flex;
  justify-content: center;
  letter-spacing: 1.5px;
}
h1 {
  font-family: 'fet', sans-serif;
  line-height: 33px;
}
.article-page__share-button {
  padding-left: 30px;
  max-width: 800px;
  margin: auto auto 20px auto;
}
p {
  font-family: 'bred', sans-serif;
}

.article-page__article__markdown,
.article-page__article__ingress {
  line-height: 18px;
}

.article-page__article h1,
:deep(.article-page__article__markdown h1) {
  margin: 50px auto 20px auto;
  font-size: 30px;
  font-family: 'fet', sans-serif;
}

.article-page h2,
:deep(.article-page__article__markdown h2) {
  margin: 30px auto 15px auto;
  font-size: 25px;
  font-family: 'fet', sans-serif;
}

.article-page h3,
:deep(.article-page__article__markdown h3) {
  margin: 25px auto 15px auto;
  font-size: 22px;
  font-family: 'fet', sans-serif;
}
.article-page__article p {
  letter-spacing: 1px;
}
.article-page__article p,
:deep(.article-page__article__markdown p) {
  margin: 20px auto;
  font-size: 16px;
  font-family: 'bred', sans-serif;
}
.article-page__article a,
:deep(.article-page__article__markdown a) {
  text-decoration: none;
  word-break: break-word;
}
.article-page__article__ingress {
  font-family: 'fet', sans-serif !important;
}
:deep(.article-page__article__markdown img) {
  max-width: 400px;
  width: 100%;
  height: auto;
  object-fit: cover;
  margin: 20px auto;
}

:deep(.article-page__article__markdown iframe) {
  aspect-ratio: 16/9;
  width: 100%;
}

@media (min-width: 1024px) {
  .article-page__content {
    display: flex;
    padding-left: 40px;
    justify-content: flex-start;
  }
  .article-page__share-button {
    padding-left: 72px;
    max-width: none;
  }
}
</style>
